// Soft notices of the design system (components/feedback/SoftNotice.jsx): calm, never red.
import { h, icon } from './dom';
import { ICONS } from './icons';

export interface NoticeOptions {
  readonly text: string;
  readonly tone?: 'info' | 'amber' | 'ok';
  readonly icon?: string;
  readonly action?: { readonly label: string; readonly onClick: () => void };
  /** Milliseconds before it hides itself; omit to keep it until dismissed. */
  readonly duration?: number;
}

export class Notices {
  private readonly root: HTMLElement;

  constructor(parent: HTMLElement) {
    this.root = h('div', { class: 'notices', role: 'status', 'aria-live': 'polite' });
    parent.append(this.root);
  }

  show(opts: NoticeOptions): () => void {
    const el = h('div', { class: `notice notice--${opts.tone ?? 'info'}` }, icon(opts.icon ?? ICONS.info, 'icon notice__icon'), h('span', { class: 'notice__text' }, opts.text));
    if (opts.action) {
      const { label, onClick } = opts.action;
      const button = h('button', { type: 'button', class: 'button button--primary button--sm' }, label);
      button.addEventListener('click', onClick);
      el.append(button);
    }
    this.root.append(el);
    const hide = (): void => {
      el.remove();
    };
    if (opts.duration !== undefined) window.setTimeout(hide, opts.duration);
    return hide;
  }
}
